module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_rogaland_neg.d585c758.png";